<template>
  <div class="header">
    <div class="header__main-content">
      <div>
        <h1 class="headline">
          Software made<br/> to measure
        </h1>
        <p class="desc gt-xs">
          We develop <span class="highlight">software for fintech</span>
          companies used by thousands of users all around the world.
          We aim to make our <span class="highlight">UX accesible for everyone.</span>
        </p>
      </div>
      <div class="contact-info gt-xs row justify-end">
        <div>
          <p>3 Ashley Road</p>
          <p>Bournemouth, England, BH1 4LE</p>
        </div>
        <div>
          <a class="line-link" href="mailto:contact@feat.software">contact@feat.software</a>
        </div>
      </div>
    </div>
    <div class="row justify-end header-img-row">
      <div class="header-img-wrap">
        <img class="header-img"
             :src="require(`../../assets/home_header_${viewport.name}.png`)"
             alt=""/>
        <ButtonCTA to="/contact" color="green" class="btn--hire-us">
          Hire us
        </ButtonCTA>
      </div>
    </div>
    <p class="desc xs">
      We develop <span class="highlight">software for fintech</span>
      companies used by thousands of users all around the world.
      We aim to make our <span class="highlight">UX accesible for everyone.</span>
    </p>
  </div>
</template>

<script>
import { mapState } from 'vuex';


export default {
  name: 'Header',
  computed: {
    ...mapState('viewport', ['viewport']),
  },
};
</script>

<style scoped lang="stylus">
  @import '../../styles/variables';
  .headline{
    font-size: 38px;
    line-height: 47px;
    padding: 0 0 35px;
    font-family: 'Dosis', sans-serif;
    font-weight: 200;
  }

  .desc{
    padding: 70px 0 45px;
    text-align: center;
    padding-right: 40px;
  }

    .highlight{
      color: #40b8ff;
    }

  .header{
    padding-left: 40px;
    z-index: 611;
    position: relative;
  }
    .header-img-wrap{
      position: relative;
    }

  .btn--hire-us{
    position: absolute;
    bottom: 0;
    left: 0;

    &:focus{
      outline: none;
    }
  }

  .arrow-wrap{
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;


    .arrow-tail{
      width: 30px;
      height: 2px;
      background: white;
    }
    .arrow-tip{
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 4.5px 0 4.5px 7.8px;
      border-color: transparent transparent transparent white;
    }
  }

  @media(min-width: $breakpoint-sm-min){
    .headline{
      font-size: 60px;
      line-height: 67px;
      padding-bottom: 45px;
    }
    .desc{
      padding-top: 0;
      text-align: left;
      max-width: 500px;
      padding-right: 0;
      font-size: 20px;
      line-height: 36px;
    }
    .contact-info{
      max-width: 500px;
      text-align: right;
      font-size: 14px;
      color: #7C7C7C;
      line-height: 26px;
      padding-top: 80px;
      padding-bottom: 55px;

      p{
        font-size: 14px;
        color: #7C7C7C;
        line-height: 26px;
      }

      & > div{
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
      }

      div:first-child{
        padding-right: 50px;
      }


      a{
        display: block;
        font-weight: 300;
      }
    }

    .headline, .desc{
      padding-left: 65px;
    }

    .header{
      padding-left: 95px;
    }

    .btn--hire-us{
      top: 0;
      bottom: auto;
    }
  }

  @media(min-width: $breakpoint-md-min){
    .header{
      padding-right: 95px;
    }

    .header__main-content{
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      max-width: 1120px;
      margin: 0 auto;
      padding-bottom: 145px;
    }

    .header-img-row{
      justify-content: center;
    }

    .desc, .headline{
      padding-left: 80px;
    }

    .desc{
      padding-bottom: 0;
    }

    .contact-info{
      padding-bottom: 0;
      padding-top: 0;
      flex-direction: column;
      position: relative;
      top: -5px;

      div{
        padding-right: 80px;
        &:first-child{
          padding-right: 80px;
          padding-bottom: 40px;
        }
      }
    }
  }

  @media (min-width: $breakpoint-lg-min) {
    .header__main-content{
      max-width: 1519px;
    }
    .headline{
      font-size: 80px;
      line-height: 91px;
    }
    .desc{
      font-size: 22px;
      line-height: 36px;
    }
  }
</style>
